import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import {
  ButtonSquare,
  Dropdown,
  Icon,
  SwitchGridListValue,
} from '../../../../shared/ui';

import { FC, useMemo } from 'react';
import { IconMap } from '../../../../shared/sprite';
import { useRecordDropdownItems } from '../../hooks';
import { VideoRecordType } from '@distribute/shared/api-types/video-record';
import { cn } from '@distribute/frontend/utils';

type Props = {
  isShowCopyLink?: boolean;
  isShowRename?: boolean;
  view: SwitchGridListValue;
  record: VideoRecordType;
};

export const RecordDropdown: FC<Props> = ({
  isShowCopyLink = false,
  isShowRename = false,
  record,
  view,
}) => {
  const recordDropdownItems = useRecordDropdownItems({
    isShowCopyLink,
    isShowRename,
    record,
  });

  const buttonProps = useMemo(() => {
    if (view === 'grid') {
      return {
        variant: 'secondary-gray',
        size: 'sm',
        className:
          'bg-base-white/70 backdrop-blur-sm hover:border-gray-300 focus:outline-none',
      } as const;
    }

    return {
      variant: 'tertiary-gray',
      className: 'w-8 h-8 rounded-lg focus:outline-none',
    } as const;
  }, [view]);

  return (
    <Dropdown
      isModalMode={view === 'list'}
      preventEventBubbling
      listStyles="shadow-lg"
      triggerComponent={
        <DropdownMenu.Trigger asChild>
          <ButtonSquare {...buttonProps}>
            <Icon
              glyph={IconMap.DotsVertical}
              width={20}
              className={cn({ 'rotate-90': view === 'list' })}
            />
          </ButtonSquare>
        </DropdownMenu.Trigger>
      }
      items={recordDropdownItems}
    />
  );
};
